export { default } from './MapesAnimats';
